import React, {FC} from 'react'
import {Row, Col, Card} from 'react-bootstrap'

type Props = {
  statistic: any
}

const DashboardCards: FC<Props> = ({statistic}) => {
  const cards = [
    {
      id: 1,
      icon: 'bi bi-people text-primary',
      value: statistic?.total ?? 0,
      label: 'Total Pengajuan',
      bg: 'rgba(255, 165, 0, 0.1)',
    },
    {
      id: 2,
      icon: 'bi bi-clock',
      value: statistic?.pending ?? 0,
      label: 'Menunggu Review',
      note: '+0 hari ini',
      noteColor: 'text-blue',
      bg: 'rgba(219, 234, 254, 0.5)',
    },
    {
      id: 3,
      icon: 'bi bi-check-circle text-success',
      value: statistic?.approved ?? 0,
      label: 'Disetujui',
      note: '0% tingkat approval',
      noteColor: 'text-success',
      bg: 'rgba(46, 204, 113, 0.1)',
    },
    {
      id: 4,
      icon: 'bi bi-x-circle text-danger',
      value: statistic?.rejected ?? 0,
      label: 'Ditolak',
      bg: 'rgba(231, 76, 60, 0.1)',
    },
  ]

  return (
    <div className='my-4'>
      <Row>
        {cards.map((item) => (
          <Col md={3} sm={6} xs={12} key={item.id} className='mb-3'>
            <Card className='shadow-sm border-0 rounded-4 h-100 position-relative overflow-hidden'>
              {/* Dekorasi bulatan di pojok kanan atas */}
              <div
                style={{
                  position: 'absolute',
                  top: '-30px',
                  right: '-30px',
                  width: '100px',
                  height: '100px',
                  borderRadius: '50%',
                  backgroundColor: item.bg,
                }}
              />

              <Card.Body>
                {/* Bagian icon + note sejajar */}
                <div className='d-flex justify-content-between align-items-center mb-3'>
                  <div
                    className='d-inline-flex align-items-center justify-content-center rounded-3'
                    style={{
                      width: '50px',
                      height: '50px',
                      backgroundColor: item.bg,
                    }}
                  >
                    <i className={item.icon} style={{fontSize: '24px'}}></i>
                  </div>
                  {item.note && <p className={`fw-semibold ${item.noteColor}`}>{item.note}</p>}
                </div>

                {/* Angka dan label */}
                <h4 className='fw-bold'>{item.value}</h4>
                <p className='text-muted mb-0'>{item.label}</p>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  )
}

export default DashboardCards
